<template>
  <div class="pad pad-unavailable">
    <pad-frame
      :thumbnail_url="hotel.thumbnail_url"
      wrap_class="pad__wrap--20"
    >
      <pad-heading :hotel="hotel" />
      <div class="pad-unavailable__body">
        <p class="pad-unavailable__message mb-1">
          <vb-icon class="mr-1" :name="'info'" :color="sass('danger')" :size="14" />
          Questa soluzione non è disponibile sul nostro sito nelle date {{ format_stay_range(checkin, checkout, { with_year: true }) }}
        </p>
        <template v-if="alternative_dates.length">
          <p class="pad-unavailable__subtitle">C'è ancora disponibilità in queste date:</p>
          <div class="pad-unavailable__dates">
            <vb-button
              v-for="(dates, index) in alternative_dates"
              :key="_uid + 'alternative_dates' + index"
              class="pad-unavailable__date"
              :vb_options="{
                text: format_stay_range(dates.checkin, dates.checkout),
                variant: 'outline-info',
                size: 'sm',
              }"
              @click="on_date_select(dates)"
            />
          </div>
        </template>
      </div>
    </pad-frame>
  </div>
</template>

<script>
import { format_stay_range } from '@/utilities/calendar'
import { rybbit_event } from '@/utilities'
import PadFrame from "@liveeps/components/blocks/pad-frame.vue"
import PadHeading from "@liveeps/components/blocks/pad-heading.vue"

export default {
  name: "pad-unavailable",

  components: {
    'pad-frame': PadFrame,
    'pad-heading': PadHeading,
  },

  props: {
    hotel: Object,
    checkin: String,
    checkout: String,
    alternative_dates: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    this.format_stay_range = format_stay_range
  },

  mounted() {
    if (this.alternative_dates.length === 0) return
    rybbit_event('search:alternative-dates:shown', {
      alternative_dates: this.alternative_dates,
    })
  },

  methods: {
    on_date_select(dates) {
      this.$emit('select', { checkin: dates.checkin, checkout: dates.checkout })
      rybbit_event('search:alternative-dates:select', {
        requested_dates: { checkin: this.checkin, checkout: this.checkout },
        selected_dates: { checkin: dates.checkin, checkout: dates.checkout },
        alternative_dates: this.alternative_dates,
      })
    },
  },
}
</script>

<style lang="scss" scoped>

  .pad {
    position: relative;
  }

  .pad-unavailable {

    &__body {
      border-top: 1px solid $gray-300;
      margin-top: $grid-gutter-width / 2;
      padding-top: $grid-gutter-width / 2;
    }

    &__message {
      display: flex;
      align-items: center;
      color: var(--danger);
      font-size: $font-size-md;
    }

    &__subtitle {
      font-size: $font-size-md;
      margin-bottom: $grid-gutter-width / 3;
    }

    &__dates {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      gap: $grid-gutter-width / 3;
    }

    &__date {
      white-space: nowrap;
    }
  }

</style>
